import { gate as v3Gate } from 'hub-http/gates';
import { hasGate } from './auth';
export const M1_GATE = v3Gate('Commerce:ContractsObjectBeta');
export function hasContractM1Gate() {
  return hasGate(M1_GATE);
}
export const useHasContractM1Gate = () => hasContractM1Gate();
export const M2_CHANGES_WITHOUT_PRORATION = v3Gate('Commerce:Contracts:M2:ChangesWithoutProration');
export function hasM2ChangesWithoutProrationGate() {
  return hasGate(M2_CHANGES_WITHOUT_PRORATION);
}
export const M2_DOWNGRADE_WITH_PRORATION = v3Gate('Commerce:Contracts:M2:DowngradeWithProration');
export function hasM2DowngradeWithProrationGate() {
  return hasGate(M2_DOWNGRADE_WITH_PRORATION);
}
export const M2_UPGRADE_WITH_PRORATION = v3Gate('Commerce:Contracts:M2:UpgradeWithProration');
export function hasM2UpgradeWithProrationGate() {
  return hasGate(M2_UPGRADE_WITH_PRORATION);
}